export const SessionDataGetSchema = {
    portalName: 'portalName',
    serviceCenterName: 'serviceCenterName',
    serviceCenterTimeZone: 'serviceCenterTimeZone',
    userId: 'userId',
    userRole: 'userRole',
    adminRoleValues: {
        administrator: 'Administrator',
        readOnly: 'ReadOnly',
        multiDomain: 'MultiDomain',
        multiDomainReadOnly: 'MultiDomainReadOnly'
    },
    isPortalTwoFactorAuthenticationEnabled: 'isPortalTwoFactorAuthenticationEnabled',
    isSystemTwoFactorAuthenticationEnabled: 'isSystemTwoFactorAuthenticationEnabled',
    isCyberViewsEnabled: 'isCyberViewsEnabled',
    isSMELogsEnabled: 'isSMELogsEnabled',
    isSMEReportEnabled: 'isSMEReportEnabled',
    isReportConfirmationEnabled: 'isReportConfirmationEnabled',
    isHasEditPermissionForReportsConfig: 'isHasEditPermissionForReportsConfig',
    minimumPasswordLength: 'minimumPasswordLength',
    maximumPasswordLength: 'maximumPasswordLength',
    minimumPortalPasswordLength: 'minimumPortalPasswordLength',
    maximumPortalPasswordLength: 'maximumPortalPasswordLength',
    allPortals: 'allPortals',
    availablePortals: 'availablePortals',
    availableServerGroups: 'availableServerGroups',
    availablePlans: 'availablePlans',
    availableRoles: 'availableRoles',
    availableSystemRoles: 'availableSystemRoles',
    availableCommunities: 'availableCommunities',
    failedTasksCount: 'failedTasksCount'
}